module.exports = __webpack_public_path__ + "static/media/verified-icon.fb3e26b3.svg";